import * as GOVUKFrontend from "govuk-frontend";
import { initAll } from './src/all.js';

GOVUKFrontend.initAll();
initAll();

